import { BaseDropdown } from './component/BaseDropdown';
import { useDropdownOptions } from '../../hooks/useDropdownOptions';
import { BusinessDropdownProps } from './component/type';

const COLUMN_NAMES: string[] = ['Code', 'Description'];

export const SignaturesDropdown = (props: BusinessDropdownProps) => {
  const shouldPreventApiCall = props.disabled || props.readOnly;

  const { options: signaturesOptions, loading } = useDropdownOptions({
    apiId: 'internal.v1.base-tables',
    operationId: 'GET /promptValues/{windowId}',
    labelAttribute: 'signature',
    valueAttribute: 'signature',
    params: {
      windowId: 'signatures',
    },
    shouldPreventApiCall,
  });

  return <BaseDropdown {...props} loading={loading} options={signaturesOptions} columnNames={COLUMN_NAMES} />;
};
